export var HolographicBoundsType;
(function (HolographicBoundsType) {
    HolographicBoundsType[HolographicBoundsType["BOX"] = 0] = "BOX";
    HolographicBoundsType[HolographicBoundsType["CYLINDER"] = 1] = "CYLINDER";
    HolographicBoundsType[HolographicBoundsType["SPHERE"] = 2] = "SPHERE";
})(HolographicBoundsType || (HolographicBoundsType = {}));
export function IsHolographicBounds(obj) {
    return typeof obj === "object" && obj !== null && (obj.type === undefined || Object.values(HolographicBoundsType).includes(obj.type));
}
export var ClipIndex;
(function (ClipIndex) {
    ClipIndex[ClipIndex["North"] = 0] = "North";
    ClipIndex[ClipIndex["South"] = 1] = "South";
    ClipIndex[ClipIndex["East"] = 2] = "East";
    ClipIndex[ClipIndex["West"] = 3] = "West";
    ClipIndex[ClipIndex["Top"] = 4] = "Top";
    ClipIndex[ClipIndex["Bottom"] = 5] = "Bottom";
})(ClipIndex || (ClipIndex = {}));
export class ClipPlaneDefinition {
    constructor(index, point, normal) {
        this.index = index;
        this.point = point;
        this.normal = normal;
    }
}
export function IsHolographicBox(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    return obj.type === HolographicBoundsType.BOX;
}
export function IsHolographicCylinder(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    return obj.type === HolographicBoundsType.CYLINDER;
}
export function IsHolographicSphere(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    return obj.type === HolographicBoundsType.SPHERE;
}
export function HasHolographicBounds(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    return obj.holographicBounds !== undefined;
}
//# sourceMappingURL=display.holographic.bounds.js.map